/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'multi-tenancy': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M213.333 562.347v170.666L512 896l298.667-162.987V562.347L512 725.333 213.333 562.347zM512 128L42.667 384 512 640l384-209.493v294.826h85.333V384L512 128z"/>'
  }
})
